import React from 'react';
export function PrivacyPage() {
  return <div className="min-h-screen bg-white py-12 px-6" data-id="element-412">
      <div className="max-w-3xl mx-auto" data-id="element-413">
        <div className="mb-8" data-id="element-414">
          <h1 className="text-4xl font-bold text-[#2C3E50] mb-4" data-id="element-415">
            Política de Privacidad y Protección de Datos
          </h1>
        </div>

        <div className="space-y-6 text-[#2C3E50]" data-id="element-416">
          <section data-id="element-417">
            <h2 className="text-xl font-semibold mb-3 text-[#5B9BD5]" data-id="element-418">
              1. INTRODUCCIÓN
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-419">
              En la Cámara Ecuatoriana de Emprendimiento y Desarrollo Sostenible
              (CEDES) valoramos y respetamos la privacidad de nuestros usuarios.
              Esta Política de Privacidad describe cómo recopilamos, utilizamos,
              almacenamos y protegemos los datos personales que usted nos
              proporciona al utilizar nuestro sitio web www.cedes.ec u otros
              canales de comunicación.
            </p>
          </section>

          <section data-id="element-420">
            <h2 className="text-xl font-semibold mb-3 text-[#5B9BD5]" data-id="element-421">
              2. RESPONSABLE DEL TRATAMIENTO
            </h2>
            <div className="text-gray-700 leading-relaxed space-y-2" data-id="element-422">
              <p data-id="element-423">
                <strong data-id="element-424">Nombre de la entidad:</strong> Cámara Ecuatoriana de
                Emprendimiento y Desarrollo Sostenible (CEDES).
              </p>
              <p data-id="element-425">
                <strong data-id="element-426">Dirección Legal:</strong> Edificio The Point, Oficina
                1803, Puerto Santa Ana, Guayaquil, Ecuador.
              </p>
              <p data-id="element-427">
                <strong data-id="element-428">Correo electrónico de contacto:</strong>{' '}
                contacto@cedes.ec.
              </p>
            </div>
          </section>

          <section data-id="element-429">
            <h2 className="text-xl font-semibold mb-3 text-[#5B9BD5]" data-id="element-430">
              3. DATOS PERSONALES QUE RECOPILAMOS
            </h2>
            <p className="text-gray-700 leading-relaxed mb-3" data-id="element-431">
              Podemos recopilar los siguientes datos personales cuando navegas o
              interactúas con nuestro sitio web u otros canales:
            </p>
            <ul className="space-y-2 text-gray-700 leading-relaxed" data-id="element-432">
              <li className="flex gap-2" data-id="element-433">
                <span className="text-[#5B9BD5] font-bold" data-id="element-434">•</span>
                <span data-id="element-435">Nombres y apellidos</span>
              </li>
              <li className="flex gap-2" data-id="element-436">
                <span className="text-[#5B9BD5] font-bold" data-id="element-437">•</span>
                <span data-id="element-438">Correo electrónico</span>
              </li>
              <li className="flex gap-2" data-id="element-439">
                <span className="text-[#5B9BD5] font-bold" data-id="element-440">•</span>
                <span data-id="element-441">Número de teléfono</span>
              </li>
              <li className="flex gap-2" data-id="element-442">
                <span className="text-[#5B9BD5] font-bold" data-id="element-443">•</span>
                <span data-id="element-444">Información de empresa o emprendimiento</span>
              </li>
              <li className="flex gap-2" data-id="element-445">
                <span className="text-[#5B9BD5] font-bold" data-id="element-446">•</span>
                <span data-id="element-447">
                  Dirección IP y datos de navegación (cookies, ubicación, tipo
                  de navegador)
                </span>
              </li>
              <li className="flex gap-2" data-id="element-448">
                <span className="text-[#5B9BD5] font-bold" data-id="element-449">•</span>
                <span data-id="element-450">
                  Información proporcionada mediante formularios de contacto o
                  suscripción
                </span>
              </li>
            </ul>
          </section>

          <section data-id="element-451">
            <h2 className="text-xl font-semibold mb-3 text-[#5B9BD5]" data-id="element-452">
              4. FINALIDAD DEL TRATAMIENTO
            </h2>
            <p className="text-gray-700 leading-relaxed mb-3" data-id="element-453">
              Recopilamos tus datos con las siguientes finalidades:
            </p>
            <ul className="space-y-2 text-gray-700 leading-relaxed" data-id="element-454">
              <li className="flex gap-2" data-id="element-455">
                <span className="text-[#5B9BD5] font-bold" data-id="element-456">•</span>
                <span data-id="element-457">
                  Enviar información institucional, boletines, eventos y
                  servicios de la Cámara
                </span>
              </li>
              <li className="flex gap-2" data-id="element-458">
                <span className="text-[#5B9BD5] font-bold" data-id="element-459">•</span>
                <span data-id="element-460">
                  Atender consultas o solicitudes realizadas a través de
                  formularios de contacto
                </span>
              </li>
              <li className="flex gap-2" data-id="element-461">
                <span className="text-[#5B9BD5] font-bold" data-id="element-462">•</span>
                <span data-id="element-463">Gestionar inscripciones a eventos o programas</span>
              </li>
              <li className="flex gap-2" data-id="element-464">
                <span className="text-[#5B9BD5] font-bold" data-id="element-465">•</span>
                <span data-id="element-466">
                  Realizar análisis estadísticos de navegación (uso de cookies)
                </span>
              </li>
              <li className="flex gap-2" data-id="element-467">
                <span className="text-[#5B9BD5] font-bold" data-id="element-468">•</span>
                <span data-id="element-469">Cumplir con obligaciones legales y regulatorias</span>
              </li>
            </ul>
          </section>

          <section data-id="element-470">
            <h2 className="text-xl font-semibold mb-3 text-[#5B9BD5]" data-id="element-471">
              5. LEGITIMACIÓN PARA EL TRATAMIENTO
            </h2>
            <p className="text-gray-700 leading-relaxed mb-3" data-id="element-472">
              El tratamiento de tus datos se realiza con base en:
            </p>
            <ul className="space-y-2 text-gray-700 leading-relaxed" data-id="element-473">
              <li className="flex gap-2" data-id="element-474">
                <span className="text-[#5B9BD5] font-bold" data-id="element-475">•</span>
                <span data-id="element-476">Tu consentimiento expreso</span>
              </li>
              <li className="flex gap-2" data-id="element-477">
                <span className="text-[#5B9BD5] font-bold" data-id="element-478">•</span>
                <span data-id="element-479">
                  El interés legítimo de CEDES para cumplir su misión
                  institucional
                </span>
              </li>
              <li className="flex gap-2" data-id="element-480">
                <span className="text-[#5B9BD5] font-bold" data-id="element-481">•</span>
                <span data-id="element-482">
                  El cumplimiento de obligaciones legales, según la normativa
                  ecuatoriana aplicable (Ley Orgánica de Protección de Datos
                  Personales – LOPDP)
                </span>
              </li>
            </ul>
          </section>

          <section data-id="element-483">
            <h2 className="text-xl font-semibold mb-3 text-[#5B9BD5]" data-id="element-484">
              6. DESTINATARIOS DE LOS DATOS
            </h2>
            <p className="text-gray-700 leading-relaxed mb-3" data-id="element-485">
              Tus datos personales no serán compartidos con terceros, salvo que:
            </p>
            <ul className="space-y-2 text-gray-700 leading-relaxed" data-id="element-486">
              <li className="flex gap-2" data-id="element-487">
                <span className="text-[#5B9BD5] font-bold" data-id="element-488">•</span>
                <span data-id="element-489">Tengamos tu consentimiento previo</span>
              </li>
              <li className="flex gap-2" data-id="element-490">
                <span className="text-[#5B9BD5] font-bold" data-id="element-491">•</span>
                <span data-id="element-492">
                  Sea requerido por autoridad competente conforme a la ley
                </span>
              </li>
              <li className="flex gap-2" data-id="element-493">
                <span className="text-[#5B9BD5] font-bold" data-id="element-494">•</span>
                <span data-id="element-495">
                  Se usen herramientas tecnológicas de terceros (por ejemplo,
                  para envío de newsletters, CRM o formularios) con contratos
                  que garantizan la protección de tus datos
                </span>
              </li>
            </ul>
          </section>

          <section data-id="element-496">
            <h2 className="text-xl font-semibold mb-3 text-[#5B9BD5]" data-id="element-497">
              7. DERECHOS DEL TITULAR DE LOS DATOS
            </h2>
            <p className="text-gray-700 leading-relaxed mb-3" data-id="element-498">
              Tienes derecho a:
            </p>
            <ul className="space-y-2 text-gray-700 leading-relaxed mb-3" data-id="element-499">
              <li className="flex gap-2" data-id="element-500">
                <span className="text-[#5B9BD5] font-bold" data-id="element-501">•</span>
                <span data-id="element-502">Acceder a tus datos personales</span>
              </li>
              <li className="flex gap-2" data-id="element-503">
                <span className="text-[#5B9BD5] font-bold" data-id="element-504">•</span>
                <span data-id="element-505">Rectificar datos inexactos o incompletos</span>
              </li>
              <li className="flex gap-2" data-id="element-506">
                <span className="text-[#5B9BD5] font-bold" data-id="element-507">•</span>
                <span data-id="element-508">Eliminar tus datos (cuando proceda)</span>
              </li>
              <li className="flex gap-2" data-id="element-509">
                <span className="text-[#5B9BD5] font-bold" data-id="element-510">•</span>
                <span data-id="element-511">Oponerte al tratamiento</span>
              </li>
              <li className="flex gap-2" data-id="element-512">
                <span className="text-[#5B9BD5] font-bold" data-id="element-513">•</span>
                <span data-id="element-514">Solicitar la portabilidad de tus datos</span>
              </li>
              <li className="flex gap-2" data-id="element-515">
                <span className="text-[#5B9BD5] font-bold" data-id="element-516">•</span>
                <span data-id="element-517">Revocar el consentimiento en cualquier momento</span>
              </li>
            </ul>
            <p className="text-gray-700 leading-relaxed" data-id="element-518">
              Puedes ejercer estos derechos escribiéndonos a{' '}
              <strong data-id="element-519">protecciondatos@cedes.ec</strong>
            </p>
          </section>

          <section data-id="element-520">
            <h2 className="text-xl font-semibold mb-3 text-[#5B9BD5]" data-id="element-521">
              8. USO DE COOKIES
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-522">
              Nuestros sitios utilizan cookies propias y de terceros para
              mejorar la experiencia de navegación y análisis del tráfico.
              Puedes aceptar, configurar o rechazar el uso de cookies desde el
              banner de consentimiento al ingresar al sitio.
            </p>
          </section>

          <section data-id="element-523">
            <h2 className="text-xl font-semibold mb-3 text-[#5B9BD5]" data-id="element-524">
              9. SEGURIDAD DE LA INFORMACIÓN
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-525">
              CEDES aplica medidas de seguridad técnicas y organizativas
              adecuadas para proteger tus datos personales contra accesos no
              autorizados, pérdida, destrucción o alteración.
            </p>
          </section>

          <section data-id="element-526">
            <h2 className="text-xl font-semibold mb-3 text-[#5B9BD5]" data-id="element-527">
              10. CONSERVACIÓN DE LOS DATOS
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-528">
              Tus datos serán conservados solo durante el tiempo necesario para
              cumplir con la finalidad para la que fueron recopilados o mientras
              exista una relación institucional o contractual. Posteriormente
              serán eliminados o anonimizados, según corresponda.
            </p>
          </section>

          <section data-id="element-529">
            <h2 className="text-xl font-semibold mb-3 text-[#5B9BD5]" data-id="element-530">
              11. CAMBIOS A ESTA POLÍTICA
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-531">
              Nos reservamos el derecho de modificar esta Política de Privacidad
              en cualquier momento. Cualquier cambio será publicado en esta
              página con la fecha de actualización correspondiente.
            </p>
          </section>

          <section data-id="element-532">
            <h2 className="text-xl font-semibold mb-3 text-[#5B9BD5]" data-id="element-533">
              12. AUTORIDAD DE CONTROL
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-534">
              Si consideras que tus derechos no han sido respetados, puedes
              presentar un reclamo ante la Autoridad de Protección de Datos
              Personales de Ecuador, la Superintendencia de Protección de Datos
              Personales.
            </p>
          </section>

          <section data-id="element-535">
            <h2 className="text-xl font-semibold mb-3 text-[#5B9BD5]" data-id="element-536">
              13. VIGENCIA
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-537">
              La vigencia de estas Políticas de Privacidad y Protección de Datos
              es desde el 21 de noviembre de 2025 y permanecerá vigente hasta
              que exista una nueva versión que la reemplace.
            </p>
          </section>
        </div>
      </div>
    </div>;
}